import importCSV from "../assets/svg/Import CSV.svg";
import downloadTemplate from "../assets/svg/Download Template.svg";
import generateClient from "../assets/svg/Generate Client_O_NOS.svg";
import filterIcon from "../assets/svg/filter-icon.svg";
import activeIcon from "../assets/img/statusIcons/active.png";
import resetIcon from "../assets/svg/tabler_reload.svg";
import { download } from "../services/downloadTemplate";
import {
  downloadOnos,
  downloadVnos,
} from "../enums/endpoints";

interface UrlLink {
  id: string;
  label?: string;
  icon?: string;
  isSubLinks?: boolean;
  sublinks?: Array<any>;
  shouldOpenNewTab?: boolean;
}

export interface ButtonLink extends UrlLink {
  icon?: any;
  handler?: any;
}

export const headerButtonLinks: Array<ButtonLink> = [
  {
    id: "Generate",
    icon: <img src={generateClient} alt="" />,
    label: "Generate Client_O_NOS",
  },
  {
    id: "import",
    icon: <img src={importCSV} alt="" />,
    label: "Import CSV",
    isSubLinks: true,
    sublinks: [
      {
        id: "uploadVnos",
        title: "Upload V_NOS",
        // handler: () => download(downloadVnos)
      },
      {
        id: "uploadOnos",
        title: "Upload O_NOS",
        // handler: () => download(downloadOnos)
      },
    ],
  },
  {
    id: "download",
    icon: <img src={downloadTemplate} alt="" />,
    label: "Download Template",
    isSubLinks: true,
    sublinks: [
      {
        id: "vnos",
        title: "VNOS",
        handler: () => download(downloadVnos),
      },
      {
        id: "onos",
        title: "QR Code Gen",
        handler: () => download(downloadOnos),
      },
    ],
  },
];

export const toolbarButtonLinks: Array<ButtonLink> = [
  {
    id: "filters",
    icon: <img src={filterIcon} alt="" className="imageContainerResponsive"/>,
    label: "Filters",
  },
  {
    id:"reset",
    icon: <img src={resetIcon} alt="" className="imageContainerResponsive"/>,
    label: "Reset",
  },
  {
    id: "update",
    icon: <img src={activeIcon} alt=""/>,
    label: "Update Status",
  },
];
